import { QueryState } from "@/ds/custom/QueryState";
import { useNotification } from "@/features/notifications/api/useNotification";
import dayjs from "dayjs";
import Markdown from "react-markdown";

export interface NotificationPreviewDisplayProps {
	notificationId: string;
}

export const NotificationPreviewDisplay = ({ notificationId }: NotificationPreviewDisplayProps) => {
	const notification = useNotification(notificationId);

	return (
		<QueryState query={notification}>
			{
				data => (
					<div className="p-6">
						<div className="flex items-center mb-4">
							<div className="type-title pr-3 grow">{data.subject}</div>
							<div className="type-meta whitespace-nowrap">{dayjs(data.created).format("DD MMM YYYY")}</div>
						</div>

						<div className="type-description [&_ul]:mb-4 [&_ul]:mt-4">
							<Markdown>
								{data.message}
							</Markdown>
						</div>
					</div>
				)
			}
		</QueryState>
	);
};
